import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import Reservas from "./Reservas";
import AdminDashboard from "./AdminDashboard";
import { puedeVerPanel } from "./roles";
import InfoUtil from "./InfoUtil";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { auth, firestore } from "./firebase";

// 👇 NUEVO
import Camping from "./Camping";
import Dia from "./Dia";

function App() {
  const [usuario, setUsuario] = useState(undefined);

  useEffect(() => {
    let unsubPerfil = null;

    const unsubAuth = auth.onAuthStateChanged(async (fbUser) => {
      // Usuario NO autenticado
      if (!fbUser) {
        if (unsubPerfil) { unsubPerfil(); unsubPerfil = null; }
        setUsuario(null);
        return;
      }

      // Usuario autenticado → nos suscribimos a su documento en Firestore
      unsubPerfil = firestore.collection("usuarios").doc(fbUser.uid)
        .onSnapshot(
          (snap) => {
            const d = snap.exists ? snap.data() : {};

            // Fallbacks por si algo falta
            const display = fbUser.displayName || "";
            const [first = "", last = ""] = display.split(" ");

            setUsuario({
              uid: fbUser.uid,
              email: fbUser.email || "",
              nombre: d.nombre ?? first ?? "",
              apellido: d.apellido ?? last ?? "",
              celular: d.celular ?? "",
              congregacion: d.congregacion ?? "",   // ← clave para la regla de 3 meses
              rol: d.rol ?? "user",
            });
          },
          (err) => {
            console.warn("onSnapshot(usuario) error:", err);
            // Si falla la lectura, al menos exponemos lo básico
            setUsuario({
              uid: fbUser.uid,
              email: fbUser.email || "",
              nombre: "",
              apellido: "",
              celular: "",
              congregacion: "",
              rol: "user",
            });
          }
        );
    });

    // Limpieza
    return () => {
      if (unsubPerfil) unsubPerfil();
      unsubAuth();
    };
  }, []);

  if (usuario === undefined) {
    return <p>Cargando...</p>;
  }

  return (
    <Router>
      <NavBar usuario={usuario} setUsuario={setUsuario} />
      <Routes>
        <Route path="/" element={<Home usuario={usuario} />} />
        <Route path="/login" element={<Login setUsuario={setUsuario} />} />

        {/* Casas (ruta existente) */}
        <Route
          path="/reservas"
          element={usuario ? <Reservas usuario={usuario} /> : <Navigate to="/login" />}
        />

        {/* 👇 NUEVAS rutas sin romper nada */}
        <Route
          path="/camping"
          element={usuario ? <Camping usuario={usuario} /> : <Navigate to="/login" />}
        />
        <Route
          path="/dia"
          element={usuario ? <Dia usuario={usuario} /> : <Navigate to="/login" />}
        />

        <Route
          path="/info"
          element={usuario ? <InfoUtil /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin"
          element={
            usuario && puedeVerPanel(usuario)
              ? <AdminDashboard usuario={usuario} />
              : usuario
                ? <Navigate to="/reservas" />
                : <Navigate to="/login" />
          }
        />
        <Route path="*" element={<h2>Página no encontrada</h2>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
